module.exports = "::ng-deep .newClass {\r\n  display: none !important;\r\n}\r\n"